<template>
    <div class="w-full">
        <div class="text-red-500 text-sm mb-2" v-if="state.isExist">
            This email is already already on allowed list.
        </div>
        <multiselect
            v-model="props.selectedUsers"
            id="ajax-2"
            label="name"
            track-by="email"
            placeholder="Type to share"
            open-direction="bottom"
            :options="state.users"
            :multiple="true"
            :searchable="true"
            :loading="state.isLoading"
            :internal-search="false"
            :clear-on-select="true"
            :close-on-select="true"
            :options-limit="300"
            :limit="3"
            :limit-text="limitText"
            :max-height="600"
            :hide-selected="true"
            :show-labels="false"
            :show-no-options="false"
            @close="onClose"
            @select="selectUser"
            @remove="removeUser"
            @search-change="searchUsers"
        >
            <template #tag="{ option, remove }">
                <div class="flex items-center gap-2 bg-gray-100 rounded p-2">
                    <span class="text-[16px]">{{ option.email }}</span>
                    <button
                        type="button"
                        @click="remove(option)"
                        class="
                            bg-transparent
                            text-gray-500
                            flex
                            items-center
                            hover:text-gray-700 hover:bg-gray-300
                            p-1
                            rounded-lg
                        "
                    >
                        <ion-icon name="close-outline"></ion-icon>
                    </button>
                </div>
            </template>

            <template #option="props">
                <div class="flex items-center gap-2">
                    <span>Invite {{ props.option.email }}</span>
                </div>
            </template>

            <template #noResult>
                <div class="flex items-center gap-2">
                    Please enter valid email address
                </div>
            </template>

            <template #noOptions>
                <div class="flex items-center gap-2">
                    Please enter valid email address
                </div>
            </template>
        </multiselect>
    </div>
</template>

<script setup>
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.css";
import { reactive, onMounted, defineProps } from "vue";
import { debounce } from "./utils";

const emit = defineEmits(["select"]);

const props = defineProps({
    currentUsers: {
        type: Array,
        required: true,
    },
    selectedUsers: {
        type: Array,
        required: true,
    },
});

const state = reactive({
    isLoading: false,
    isExist: false,
    users: [],
});

function limitText(count) {
    return `and ${count} other users`;
}

function onClose() {
    state.users = [];
}

function selectUser(user) {
    emit("select", user);
}

function removeUser(user) {
    emit("remove", user);
}

function clearAll() {
    emit("clear");
}

function validEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}

function searchUsers(query) {
    state.isExist = false;
    if (!validEmail(query)) {
        state.users = [];
        return;
    }

    const exist = props.currentUsers.find((u) => u.email === query);
    if (exist) {
        state.isExist = true;
        state.users = [];
        return;
    }

    state.users = [
        {
            email: query,
        },
    ];
}
</script>

<style>
.multiselect__option--highlight {
    background: #048abf;
}
.multiselect__tags-wrap {
    display: flex;
    gap: 12px;
    align-items: center;
    width: 100%;
    margin-bottom: 10px;
}
.multiselect__input,
.multiselect__single {
    font-size: 14px;
}
.multiselect--active:not(.multiselect--above) .multiselect__current,
.multiselect--active:not(.multiselect--above) .multiselect__input,
.multiselect--active:not(.multiselect--above) .multiselect__tags {
    border-bottom-left-radius: 5px;
    border-bottom-right-radius: 5px;
}
</style>
